module.exports = __webpack_public_path__ + "img/about-img-2.5ee5a692.png";